<section class="release-banner" [class]="bannerStyle()" aria-live="polite" role="alert">
  <button
    mat-icon-button
    class="release-banner__close"
    type="button"
    aria-label="Dismiss release warning"
    (click)="dismiss()"
  >
    <mat-icon svgIcon="close" />
  </button>

  <header class="release-banner__header">
    @if (isWarning()) {
      <mat-icon class="release-banner__icon" aria-hidden="true">build</mat-icon>
    }
    @if (isInfo()) {
      <span>🚀</span>
    }

    <h5 class="release-banner__title">{{ heading() }}</h5>
  </header>

  <div class="release-banner__content">
    @if (isWarning()) {
      <p>
        During the {{ warningBanner()?.duration }} minutes release window,
        <strong
          >{{ releaseStartsAtUtc() | date: 'shortTime' }} - {{ releaseEndsAtUtc() | date: 'shortTime' }} ({{
            localTimeZone()
          }})</strong
        >, you may experience brief interruptions or reduced performance in IX.
      </p>

      <p>
        To avoid any inconvenience, please avoid making changes in IX during this time. Thank you for your
        understanding and patience!
      </p>

      <p class="release-banner__team">- IX Team</p>
    }
    @if (isInfo()) {
      <p>
        IX was updated with version <strong>{{ infoBanner()?.version }}</strong> on
        {{ $safeNavigationMigration(infoBanner()?.releaseDate) | date }}. Please check the
        <a href="{{ infoBanner()?.releaseNotesUrl }}" target="_blank" rel="noopener">release notes</a> to see
        all details of the release.
      </p>
    }
  </div>
</section>
